import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Box, Button, Link as MuiLink, Stack, TextField, Typography } from "@mui/material";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import * as authMod from "firebase/auth";

import AuthPageFrame from "../../../components/AuthPageFrame";
import Loader from "../../../components/Loader";
import { ModularAuth } from "../../../components/FirebaseAuth/firebase";

const cleanAuthError = (error) => {
  const raw = String(error?.message || "").trim();
  const withoutPrefix = raw.replace(/^Firebase:\s*/i, "");
  return withoutPrefix.replace(/\s*\(auth\/[^)]+\)\.?$/i, "") || "Unable to send reset email.";
};

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState({ severity: "", message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim() || loading) return;

    setLoading(true);
    setNotice({ severity: "", message: "" });
    try {
      await authMod.sendPasswordResetEmail(ModularAuth, email.trim());
      setNotice({
        severity: "success",
        message: "Password reset email sent. Check your inbox and follow the link to continue.",
      });
    } catch (error) {
      setNotice({ severity: "error", message: cleanAuthError(error) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageFrame
      eyebrow="Account recovery"
      title="Reset your password"
      subtitle="Enter the email address for your account and we will send a secure reset link."
    >
      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={1.5}>
          {!!notice.message && <Alert severity={notice.severity || "info"}>{notice.message}</Alert>}

          <TextField
            label="Email address"
            type="email"
            size="small"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            fullWidth
            required
            autoComplete="email"
            autoFocus
            sx={{my: 1}}
          />

          <Button
            type="submit"
            variant="contained"
            size="medium"
            startIcon={!loading ? <MarkEmailReadOutlinedIcon /> : null}
            disabled={loading || !email.trim()}
            sx={{ textTransform: "none", fontWeight: 850, borderRadius: 2, py: 0.95 }}
          >
            {loading ? <Loader size={22} /> : "Send reset link"}
          </Button>

          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
            Remembered your password? <MuiLink component={RouterLink} to="/signin">Back to sign in</MuiLink>
          </Typography>
        </Stack>
      </Box>
    </AuthPageFrame>
  );
};

export default ForgotPassword;
